import { AccountType } from '@/Types/Enums/accountType';
import { useContextDataStore } from '@/VueCore/stores/contextDataStore';

export default class PortalSettingsProvider {
  static getAccountType(): AccountType | undefined {
    const contextData = useContextDataStore();
    return contextData.userData?.business?.accountType;
  }

  static getSelfResponseEnabled(): boolean | undefined {
    const contextData = useContextDataStore();
    return contextData.userData?.selfResponseEnabled;
  }

  static getMaxBusinessRequestUploads(): number {
    const contextData = useContextDataStore();
    return contextData.portalSettings.maxBusinessRequestUploads;
  }

  static getMaxPartnerRequestUploads(): number {
    const contextData = useContextDataStore();
    return contextData.portalSettings.maxPartnerRequestUploads;
  }

  static getMaxCctvFolderUploadSize(): number {
    const contextData = useContextDataStore();
    return contextData.portalSettings.maximumCctvFolderUploadSize;
  }

  static getMaxUploadSize(): number {
    const contextData = useContextDataStore();
    return contextData.portalSettings.maximumUploadSize;
  }
}